import "./App.css";
import { useMemo } from "react";

import giraffe from './giraffe.gif'
import giraffe2 from './giraffe2.gif'

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet(), getMathWallet() ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button" >
          <img src="/icons/close.svg" alt="" onClick={toggleMenu}/>
        </div>
        <ul>
          <li>
         
          </li>
          <li>
            <a href="/#link1" onClick={toggleMenu}>
             
            </a>
          </li>
          <li>
            <a href="/#link2" onClick={toggleMenu}>
              Link 2
            </a>
          </li>
          <li>
            <a href="/#link3" onClick={toggleMenu}>
              Link 3
            </a>
          </li>
          <li>
            <a href="/#link4" onClick={toggleMenu}>
              Link 4
            </a>
          </li>
          <li>
            <div className="social-icons">
              <img className="nav-social" src="/icons/twitter.svg" alt="" />
              <img className="nav-social" src="/icons/discord.svg" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <a className="hide-800" href="/#link1">
            
          </a>
          <a className="hide-800" href="/#link2">
            
          </a>
          <a className="hide-800" href="/#link3">
           
          </a>
          <a className="hide-800" href="/#link4">
            
          </a>
          <div className="social-icons hide-800">
            
          </div>
        </div>
      </nav>
      <div className="content-wrapper" id="centered1">
          <header className="card" id="link1">
            <div style={{ padding: "0 24px 0 24px 0"}}>
              
              <h1 className="pb-3">ANGRY BEAR CLUB</h1>
              
              
              <img src={giraffe2} width="300px" id="gif" alt=""/>
              <p id="centtext">AFTER MINTING, ONLY LIST YOUR NFT IF IT'S FOR
OVER 5 SOL. </p><p id="centtext2">THIS WAY YOU ALONGSIDE ANYONE
ELSE WHO MINTS WILL MAKE A MINIMUM OF 7X IF
YOU DECIDE TO SELL!</p>
<div id="centtext3" >LEARN MORE AT <a id="link212" href="https://www.angrybearclub.com">ANGRYBEARCLUB.COM</a></div>
                <div> </div>
                <p id="disclaimer">
                 
                </p>
            
              <p className="text-secondary-color">
              </p>
              <img src={giraffe} height="0px" alt=""/>
            </div>
            <div>
              <ThemeProvider theme={theme}>
                <ConnectionProvider endpoint={endpoint}>
                  <WalletProvider wallets={wallets} autoConnect>
                    <WalletDialogProvider>
                      
                        <Minter
                          candyMachineId={candyMachineId}
                          
                          connection={connection}
                          startDate={startDateSeed}
                          txTimeout={txTimeout}
                          rpcHost={rpcHost}
                        />
                      
                    </WalletDialogProvider>
                  </WalletProvider>
                </ConnectionProvider>
              </ThemeProvider>
            </div>
          </header>

          

        <div>
        
        </div>

          
      </div>
    </div>
  );
};

export default App;
